import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'

class SubBU extends Component {

	isValidated() {
		return true;
	}
	
	//lambda ensures correct 'this' scope
	onChange = (e) => {
		this.props.updateStore({
			subBU: e.target.value,
		});
	}
	
	onChangePfgSignupType = (e) => {
		this.props.updateStore({
			pfgSignOnType: e.target.value,
		});
	}

	
	handlePfgSignOnChange = (event) => {
		
		this.props.updateStore({
			pfgSignOn: event.target.checked,
			showPfgSignOnOptions: event.target.checked,
			pfgSignOnType: event.target.checked ? 'USERCONTEXT' : 'NONE'
		});

	}

	render() {
        let data = this.props.getStore();

        return <div>
			<div className="container">
				<div className="row">
					<div className="col-md-8">
						<br/>
						<label htmlFor="selectBU">Select Business Unit</label>
						<span className="tooltipCustomReact" data-tip data-event={"click"} data-for='selectBU'>?</span>
							<ReactTooltip id="selectBU" effect='solid' place='right'>
								<span>Only really relevant for naming - if you are not sure WSRS (FSA) is likely the right answer.</span>
							</ReactTooltip>
						<br/>
						{generateRadioHtml(["WSRS","ANNUITIES","PSI","BANK","DTC","PCS"],"subBU", this.props.getStore, this.onChange)}
					</div>
					<div className="row">
					<div className="col-md-5">
						<br/>
						<form>          
						<div className="checkbox styled-checkbox">
							<input type="checkbox" id="checkbox13" checked={!!data.pfgSignOn} onChange={this.handlePfgSignOnChange}/>
							<label htmlFor="checkbox13">Consumer is behind PFG SignOn</label>
							<span className="tooltipCustomReact" data-tip data-event={"click"} data-for='checkbox13'>?</span>
							<ReactTooltip id="checkbox13" effect='solid' place='right'>
								<span>PFG SignOn checkbox should be selected if you know your developer application/consumer should use forgerock endpoints for generating tokens. <br/> Based on the SignOn type you choose, we add the custom attributes on the developer application.</span>
							</ReactTooltip>
						</div>          
						<br/>
						{data.showPfgSignOnOptions && 
							<div>
								<p>Will your application require User Context or Client Credentials access?</p>
								{generateRadioHtml(["USERCONTEXT", "CLIENTCREDENTIALS"], "pfgSignOnType", this.props.getStore, this.onChangePfgSignupType)}
							</div>
							}
						</form>
						<br/>
					</div>
					</div>
					</div>
				</div>
			</div>
		}
}

const generateRadioHtml = (list, name, getStore, onChange) => {
	list = list.map((item) => 
		<div key={item} className="radio hzn-radio-card">
			<input type="radio" name={name} id={item} value={item} checked={getStore()[name]===item} onChange={onChange}/>
			<label htmlFor={item}>{item}</label>
		</div>
	);
	return <div className="hzn-radio-card-wrapper">
		{list}
	</div>
}

export default SubBU;